// extracted by mini-css-extract-plugin
export var avatarContainer = "_aa-0";
export var avatarTypingWave = "_aa-i";
export var gray = "_aa-f";
export var green = "_aa-c";
export var icon = "_aa-9";
export var image = "_aa-1";
export var lg = "_aa-6";
export var md = "_aa-5";
export var presenceDot = "_aa-b";
export var red = "_aa-d";
export var sm = "_aa-4";
export var status = "_aa-a";
export var typingDot = "_aa-h";
export var typingPill = "_aa-g";
export var xl = "_aa-7";
export var xs = "_aa-3";
export var xxl = "_aa-8";
export var xxs = "_aa-2";
export var yellow = "_aa-e";